import React from "react";
import ImageThumb from "@/components/ImageThumb";

// Small round profile photo — shows the uploaded image, or a colored initial fallback.
export const Avatar = ({ src, name = "", size = 40, className = "", testid }) => {
  const dim = { width: size, height: size, minWidth: size };
  const initial = ((name || "?").trim().charAt(0) || "?").toUpperCase();
  if (src) {
    return (
      <div className={`rounded-full overflow-hidden shrink-0 ${className}`} style={dim} data-testid={testid}>
        <ImageThumb path={src} alt={name} className="w-full h-full object-cover" />
      </div>
    );
  }
  return (
    <div
      className={`rounded-full flex items-center justify-center shrink-0 ${className}`}
      style={{ ...dim, background: "#1E3A2B", color: "#F9F6F0", fontSize: Math.round(size * 0.42) }}
      data-testid={testid}
    >
      <span className="font-display leading-none">{initial}</span>
    </div>
  );
};

export default Avatar;
